import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { Button as MuiButton } from '@mui/material';
import { Box } from '../Box';
import { IconButton } from '../IconButton';
const ButtonWithoutForwardRef = ({ size = 'medium', variant = 'primary', danger = false, children, StartIcon, EndIcon, Badge, buttonType: initButtonType, component, ...props }, ref)=>{
    // The default button type used when `buttonType` is not explicitly set is determined based on the presence of
    // children. When children are falsy, an icon button is used because there would be nothing meaningful to render
    // inside the button. Otherwise, a regular button is used.
    const defaultButtonType = children ? 'button' : 'icon';
    const buttonType = initButtonType || defaultButtonType;
    // Map the variant option supplied to the appropriate MUI Button props
    const variantProps = getVariantProps(danger, variant);
    const hasIcons = !!StartIcon || !!EndIcon;
    // Icon button requires at least one icon and a non-primary variant.
    const renderIconButton = buttonType === 'icon' && hasIcons && variant !== 'primary';
    if (renderIconButton) {
        return /*#__PURE__*/ _jsxs(IconButton, {
            ...props,
            component: component ?? 'button',
            variant: variant,
            size: size,
            danger: danger,
            Badge: Badge,
            ref: ref,
            children: [
                StartIcon,
                EndIcon
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(MuiButton, {
        ...props,
        ...variantProps,
        component: component ?? 'button',
        startIcon: StartIcon,
        endIcon: EndIcon,
        size: size,
        ref: ref,
        children: [
            children,
            Badge && /*#__PURE__*/ _jsx(Box, {
                sx: {
                    position: 'absolute',
                    top: '-6px',
                    right: '-4px'
                },
                children: Badge
            })
        ]
    });
};
// Intentionally using some `any` here to around around some type errors before the casting. We have to do some casting
// here because forwardRef, generics, and TypeScript do not play nicely together.
// https://react-typescript-cheatsheet.netlify.app/docs/basic/getting-started/forward_and_create_ref/#generic-forwardrefs
// TODO: clean this up when we are able to move to React 19, which no longer requires forwardRef.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Button = /*#__PURE__*/ forwardRef(ButtonWithoutForwardRef);
function getVariantProps(danger, variant) {
    // Map from our variant options to the MUI variant options
    const variantMap = {
        primary: {
            variant: 'contained',
            color: danger ? 'error' : 'primary'
        },
        secondary: {
            variant: 'outlined',
            color: danger ? 'error' : 'secondary'
        },
        tertiary: {
            variant: 'text',
            color: danger ? 'error' : 'primary'
        }
    };
    return variantMap[variant];
}

//# sourceMappingURL=Button.js.map